import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
  pluginCreateRequest,
  pluginCreateSuccess,
  pluginCreateError,
} from 'Workspace/Plugins/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { name, pluginType } = action;

  yield put(pluginCreateRequest());
  const workspacePluginCreate = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_CREATE,
    name,
    pluginType,
  });

  if (workspacePluginCreate.type === constants.RTM_WORKSPACE_PLUGIN_CREATE_OK) {
    const plugin = workspacePluginCreate.response.plugin;
    yield put(pluginCreateSuccess(plugin));
    yield put(push(`/plugins/${plugin.pluginId}/setup`));
  } else {
    yield put(pluginCreateError());
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePluginCreate} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_CREATE, catchErrors, sendRequest, connection);
}
